import { render, staticRenderFns } from "./WorkflowPrepDetail.vue?vue&type=template&id=38525067"
import script from "./WorkflowPrepDetail.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports